import "@/style/global.css";
import "@/style/channelTalk.css";

import { QueryClientProvider } from "@tanstack/react-query";
// import { DevTools } from "jotai-devtools";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import { Routers } from "./router";

import { LoadingModal } from "@/component/common/Modal/LoadingModal";
import { Toast } from "@/component/common/Toast";
import { BridgeProvider } from "@/lib/provider/bridge-provider";
import { MixpanelProvider } from "@/lib/provider/mix-pannel-provider";
import { OfflineBanner } from "@/lib/provider/offline-provider";
import { PWAUpdatePrompt } from "@/lib/provider/pwa-update-provider";
import { queryClient } from "@/lib/tanstack-query/queryClient";
import ClarityProvider from "./lib/provider/clarity-provider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ClarityProvider>
      <MixpanelProvider>
        <QueryClientProvider client={queryClient}>
          <BridgeProvider>
            <Suspense fallback={<LoadingModal purpose={"데이터를 가져오고 있어요"} />}>
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}
              {/* <DevTools /> */}
              <Routers />
              <Toast />
              <PWAUpdatePrompt />
              <OfflineBanner />
            </Suspense>
          </BridgeProvider>
        </QueryClientProvider>
      </MixpanelProvider>
    </ClarityProvider>
  </React.StrictMode>,
);
